// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KH67zk5KwGQBbaS2CDsD{max-width:640px}`, "",{"version":3,"sources":["webpack://./web/src/components/pages/CovetrusAuthCallbackPage/CovetrusAuthCallbackPage.module.scss"],"names":[],"mappings":"AAAA,sBACI,eAAA","sourcesContent":[".modal {\n    max-width: 640px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `KH67zk5KwGQBbaS2CDsD`
};
export default ___CSS_LOADER_EXPORT___;
